import React, { useEffect, useState } from "react";
import style from "css/device.module.css";

function Mount() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className={style.device_mount_wrap}>
      <div className={style.device_mount_inner_box}>
        <div className={style.device_mount_title_wrap}>
          <div className={style.device_mount_title}>
            다양하고 유연한 설치 옵션
          </div>
          <div className={style.device_mount_text}>
            {isMobile
              ?
              <>
                적응형 스탠드 · 적응형 마운트 · 벽걸이형 ·
                <br />
                테이블 스탠드 등 사용자의 상황과 환경에 맞게
                <br />
                다양한 방법으로 설치가 가능합니다.
              </>
              :
              <>
                적응형 스탠드 · 적응형 마운트 · 벽걸이형 · 테이블 스탠드 등
                <br />
                사용자의 상황과 환경에 맞게 다양한 방법으로 설치가 가능합니다.
              </>
            }
          </div>
        </div>
        <div className={style.device_mount_type_grid}>
          <div className={style.device_mount_type_item}>
            <div
              className={style.device_mount_type_title_wrap}
              style={{ alignItems: !isMobile && "center" }}
            >
              <div className={style.device_mount_type_title}>
                <span>테이블 스탠드</span>
              </div>
              <div className={style.device_mount_type_text}>
                Neat Board 50은 캐비닛이나 테이블 위에 완벽하게 놓을 수 있도록
                디자인 되었습니다.
              </div>
            </div>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/mount_stand_table${isMobile ? "_m" : ""}.webp`
              }
              alt="table"
            />
          </div>
          <div className={style.device_mount_type_item}>
            <div className={style.device_mount_type_title_wrap}>
              <div className={style.device_mount_type_title}>
                <span>벽면 장착</span>
              </div>
              <div className={style.device_mount_type_text}>
                벽면 거치대는 VESA와 호환되며, Neat Board 50을 벽에 꼭 맞게
                설치할 수 있어 방을 더욱 스마트하게 통합하는 데 도움이 됩니다.
              </div>
            </div>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/mount_wall${isMobile ? "_m" : ""}.webp`
              }
              alt="wall"
            />
          </div>
          <div className={style.device_mount_type_item}>
            <div className={style.device_mount_type_title_wrap}>
              <div className={style.device_mount_type_title}>
                <span>적응형 마운트</span>
              </div>
              <div className={style.device_mount_type_text}>
                적응형 마운트를 사용하면 Neat Board 50을 벽에 꼭 맞게 배치하여
                실내 통합을 더욱 스마트하게 만들고 최적의 사용과 시청을 위해
                위아래로 이동할 수 있습니다.
              </div>
            </div>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/mount_wall_adaptive${isMobile ? "_m" : ""}.webp`
              }
              alt="wall_adaptive"
            />
          </div>
          <div className={style.device_mount_type_item}>
            <div className={style.device_mount_type_title_wrap}>
              <div className={style.device_mount_type_title}>
                <span>적응형 스탠드</span>
              </div>
              <div className={style.device_mount_type_text}>
                적응형 스탠드를 사용하면 Neat Board 50을 공간에서 공간으로
                옮기고 화면을 위아래로 조정할 수 있어 독보적인 사용 유연성과
                최적의 시청 환경을 제공합니다.
              </div>
            </div>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/mount_stand_adaptive${isMobile ? "_m" : ""}.webp`
              }
              alt="stand_adaptive"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mount;
